(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[51466],{

/***/ 7897:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credittent",
      function () {
        return __webpack_require__(96583);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ FreeCreditEvaluationHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_layouts_creditTentWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65753);
/* harmony import */ var _components_credittent_serviceform__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97040);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88737);





const WhyUs = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 49025).then(__webpack_require__.bind(__webpack_require__, 98646)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(98646)
            ]
    }
});
const HowThisWork = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 54461).then(__webpack_require__.bind(__webpack_require__, 54461)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(54461)
            ]
    }
});
const OffersList = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 33124).then(__webpack_require__.bind(__webpack_require__, 33124)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(33124)
            ]
    }
});
const FAQ = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 65284).then(__webpack_require__.bind(__webpack_require__, 65284)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(65284)
            ]
    }
});

var __N_SSP = true;
function FreeCreditEvaluationHome() {
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_5__/* .useDomainContext */ .w)();
    const style = {
        background: "#fff",
        borderColor: "#e3e3e3",
        buttonBackground: "#3ea636",
        buttonForground: "#fff"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_creditTentWrapper__WEBPACK_IMPORTED_MODULE_3__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_credittent_serviceform__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                style: {
                    padding: "0 15px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OffersList, {
                    offers: domain?.defaultOffers,
                    style: style
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HowThisWork, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WhyUs, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQ, {})
        ]
    });
}


/***/ }),

/***/ 97040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ServiceForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78872);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_shared_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96119);
/* harmony import */ var _styles_variables_lawyerconsultationVariables_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32771);
/* harmony import */ var _styles_variables_lawyerconsultationVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_variables_lawyerconsultationVariables_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_combinedForm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31095);




// import dynamic from "next/dynamic";


// const PopupCallUs = dynamic(() => import("@components/shared/popupCallus"));
function ServiceForm() {
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    return domain.categories?.length === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().mainBanner)}`,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().formWrapper)} py-4`,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_form__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        classes: {
                            formClassName: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().form)}`,
                            stepTitleClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-title"]),
                            stepClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-block"]),
                            stepDescriptionClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-description"]),
                            formButtonClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-button"]),
                            formFieldClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-field"]),
                            formFieldLabelClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["field-label"]),
                            formStepInnerClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["steps-inner"]),
                            fieldsClassName: {
                                radio: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["radio-field"])
                            },
                            fieldsWrapperClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["fields-wrapper"]),
                            tcpaClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tcpa),
                            labelAsTitleClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["label-as-step-title"]),
                            formSubmitButtonClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["submit-button"]),
                            sellingPointClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["selling-point"]),
                            formProgressbarClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["custom-progress"])
                        },
                        colors: {
                            primaryColor: (_styles_variables_lawyerconsultationVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().lcPrimary)
                        },
                        showProgress: true,
                        backButton: {
                            class: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["back-button"]),
                            label: "Back"
                        },
                        preventWindowClose: true,
                        popupStyle: {
                            actionBtnBgColor: "#0e5aa9",
                            actionBtnColor: "#fff",
                            iconColor: "#0e5aa9"
                        },
                        goToThankYouPage: !!domain?.defaultOffers?.length,
                        dynamicThankYouFields: [
                            "firstName"
                        ]
                    })
                })
            })
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_combinedForm__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        formClasses: {
            // formClassName: styles["form"],
            stepTitleClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-title"]),
            stepClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-block"]),
            stepDescriptionClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-description"]),
            formButtonClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-button"]),
            formFieldClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-field"]),
            formFieldLabelClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["field-label"]),
            formStepInnerClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["steps-inner"]),
            fieldsClassName: {
                radio: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["radio-field"])
            },
            fieldsWrapperClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["fields-wrapper"]),
            tcpaClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tcpa),
            labelAsTitleClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["label-as-step-title"]),
            formSubmitButtonClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["submit-button"]),
            sellingPointClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["selling-point"]),
            formProgressbarClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["custom-progress"])
        },
        mainBannerClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().mainBanner),
        primaryColor: "#168bb5",
        colors: {
            primaryColor: (_styles_variables_lawyerconsultationVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().primaryColor),
            progressBar: (_styles_variables_lawyerconsultationVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().primaryColor)
        },
        backButtonClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["back-button"]),
        blockClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().serviceBlockLnk),
        blockContainerClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["block-container"]),
        question: "What do you need help with today?",
        resetLeadId: true
    });
}


/***/ }),

/***/ 78872:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","serviceBlocks":"style_serviceBlocks__3CgQ_","mainBanner":"style_mainBanner__HKn2c","errorMessage":"style_errorMessage__Bi3iF","form":"style_form__Xs0r3","form-step-0":"style_form-step-0__qLesl","formWrapper":"style_formWrapper___qRdt","form-button":"style_form-button__I6p_1","mainTitle":"style_mainTitle__m8Rbn","form-field":"style_form-field__4Zk6v","back-button":"style_back-button__FUgcA","selling-point":"style_selling-point__YSG3k","radio-field":"style_radio-field__ZqWv0","bestLawyer":"style_bestLawyer__AB6LR","steps-inner":"style_steps-inner__5Y48s","fields-wrapper":"style_fields-wrapper__tStaq","step-block":"style_step-block__X4fjx","step-title":"style_step-title__G0vDC","label-as-step-title":"style_label-as-step-title__5U7y6","step-description":"style_step-description__zTlt5","outsideTitle":"style_outsideTitle__3LUeL","outsideBrief":"style_outsideBrief__U6oNO","submit-button":"style_submit-button__4BzCZ","blink":"style_blink__8a4LP","custom-progress":"style_custom-progress__MkJdv","mainBannerWrapper":"style_mainBannerWrapper__3GrS9","formStepsWrapper":"style_formStepsWrapper__bd4u9","stepBlock":"style_stepBlock__mJvQu","title":"style_title__LmygA","brief":"style_brief__iczeJ","buttons":"style_buttons__Yt8vL","formStepsWrapperWindow":"style_formStepsWrapperWindow__s9IB0","description":"style_description__s5nor","progress-bar":"style_progress-bar__3_1Bp","serviceBlockLnk":"style_serviceBlockLnk__61UcA","desc":"style_desc__Rwzhy","lnkTitle":"style_lnkTitle___wQoY"};

/***/ }),

/***/ 32771:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,63302,65753,35264,49774,92888,40179], function() { return __webpack_exec__(7897); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);